'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.error = exports.success = exports.start = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The start action for the remove reducer
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var start = exports.start = function start(state, action) {
	//console.log(action);

	if (_immutable.List.isList(action.uid)) {
		var records = action.uid;

		records.map(function (record) {
			state = state.withMutations(function (map) {
				//const removalId = record.get(action.uidField).toString()

				//console.log(record);
				var removalId = record.toString();
				//console.log(removalId);

				// Pessimistic removal
				if (action.isAsync) {
					// Add uid to pending.remove
					var pendingRemove = map.getIn(['pending', 'remove'], (0, _immutable.List)());
					map.setIn(['pending', 'remove'], pendingRemove.insert(0, removalId));
				}
				// Remove the item from raw and all instances
				else {
						// Remove the item from raw
						map.deleteIn(['raw', removalId]);

						// Remove uid from all instances
						map.get('instances').entrySeq().forEach(function (item) {
							var instanceKey = item[0];
							var instanceUids = item[1].get('data');
							var uidIndexInInstance = instanceUids.indexOf(removalId);

							// If the uid of the item to be removed exists in this instance, remove it
							if (uidIndexInInstance > -1) {
								map.removeIn(['instances', instanceKey, 'data', uidIndexInInstance]);
							}
						});
					}
			});
		});

		state = state.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
			error: false,
			errorMessage: null,
			isDeleting: true,
			isFetching: false,
			isFetchingSingle: false
		})));

		return state;
	} else {
		return state.withMutations(function (map) {
			var removalId = action.uid.toString();

			// Pessimistic removal
			if (action.isAsync) {
				// Add uid to pending.remove
				var pendingRemove = map.getIn(['pending', 'remove'], (0, _immutable.List)());
				map.setIn(['pending', 'remove'], pendingRemove.insert(0, removalId));
			}
			// Remove the item from raw and all instances
			else {
					// Remove the item from raw
					map.deleteIn(['raw', removalId]);

					// Remove uid from all instances
					map.get('instances').entrySeq().forEach(function (item) {
						var instanceKey = item[0];
						var instanceUids = item[1].get('data');
						var uidIndexInInstance = instanceUids.indexOf(removalId);

						// If the uid of the item to be removed exists in this instance, remove it
						if (uidIndexInInstance > -1) {
							map.removeIn(['instances', instanceKey, 'data', uidIndexInInstance]);
						}
					});
				}
		});
	}
};

/**
 * The success action for the remove reducer
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var success = exports.success = function success(state, action) {

	if (_immutable.List.isList(action.uid)) {
		var records = action.uid;

		records.map(function (record) {

			state = state.withMutations(function (map) {
				//const removalId = record.get(action.uidField).toString();
				//console.log(record);
				var removalId = record.toString();
				//console.log(removalId);

				// Remove uid from pending.remove
				var pendingRemove = map.getIn(['pending', 'remove'], (0, _immutable.List)());
				var uidIndexInPendingRemove = pendingRemove.indexOf(removalId);
				map.removeIn(['pending', 'remove', uidIndexInPendingRemove]);

				// Remove the item from raw
				map.deleteIn(['raw', removalId]);

				// Remove uid from all instances
				map.get('instances').entrySeq().forEach(function (item) {
					var instanceKey = item[0];
					var instanceUids = item[1].get('data');
					var uidIndexInInstance = instanceUids.indexOf(removalId);

					// If the uid of the item to be removed exists in this instance, remove it
					if (uidIndexInInstance > -1) {
						map.removeIn(['instances', instanceKey, 'data', uidIndexInInstance]);

						// UPDATE TOTAL COUNT FOR THIS INSTANCE
						map.setIn(['instances', instanceKey, 'additionalData', 'total'], map.getIn(['instances', instanceKey, 'additionalData', 'total']) - 1);
					}
				});
			});
		});

		state = state.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
			error: false,
			errorMessage: null,
			isDeleting: false
		})));

		return state;
	} else {

		return state.withMutations(function (map) {
			var removalId = action.uid.toString();

			// Remove uid from pending.remove
			var pendingRemove = map.getIn(['pending', 'remove'], (0, _immutable.List)());
			var uidIndexInPendingRemove = pendingRemove.indexOf(removalId);
			map.removeIn(['pending', 'remove', uidIndexInPendingRemove]);

			// Remove the item from raw
			map.deleteIn(['raw', removalId]);

			// Remove uid from all instances
			map.get('instances').entrySeq().forEach(function (item) {
				var instanceKey = item[0];
				var instanceUids = item[1].get('data');
				var uidIndexInInstance = instanceUids.indexOf(removalId);

				// If the uid of the item to be removed exists in this instance, remove it
				if (uidIndexInInstance > -1) {
					map.removeIn(['instances', instanceKey, 'data', uidIndexInInstance]);

					// UPDATE TOTAL COUNT FOR THIS INSTANCE
					map.setIn(['instances', instanceKey, 'additionalData', 'total'], map.getIn(['instances', instanceKey, 'additionalData', 'total']) - 1);
				}
			});
		});
	}
};

/**
 * The error action for the remove reducer
 * Re-adds the record on error because the request failed
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var error = exports.error = function error(state, action) {

	if (_immutable.List.isList(action.uid)) {
		var records = action.uid;

		records.map(function (record) {
			//const removalId = record.get(action.uidField).toString();
			//console.log(record);
			var removalId = record.toString();
			//console.log(removalId);

			state = state.withMutations(function (map) {
				// Remove uid from pending.remove
				var pendingRemove = map.getIn(['pending', 'remove'], (0, _immutable.List)());
				var uidIndexInPendingRemove = pendingRemove.indexOf(removalId);
				map.removeIn(['pending', 'remove', uidIndexInPendingRemove]);
			});
		});

		state = state.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
			error: true,
			errorMessage: action.responseData,
			isDeleting: false
		})));

		return state;
	} else {

		var removalId = action.uid.toString();

		return state.withMutations(function (map) {
			// Remove uid from pending.remove
			var pendingRemove = map.getIn(['pending', 'remove'], (0, _immutable.List)());
			var uidIndexInPendingRemove = pendingRemove.indexOf(removalId);
			map.removeIn(['pending', 'remove', uidIndexInPendingRemove]);
		});
	}
};

exports.default = {
	start: start,
	success: success,
	error: error
};